























































































import { Component, Vue } from 'vue-property-decorator'
import { State, Action, Mutation } from 'vuex-class'
import { NAV_MAP, PLAY_IDS } from '../utils/constants'
import { $condition, $getPlayIds } from '../api/http'
import * as toast from '@bilibili/vanilla-toast'

import {
  SEASON_TYPE_MAP,
  INDEX_TYPE_MAP,
  TYPE_MAP,
  NAV_NAME_MAP,
  FIELD_MAP,
} from '../utils/constants'

@Component({
  name: 'FilterNav',
  filters: {
    formatNavName: (item) => {
      return NAV_NAME_MAP[item.field]
    },
  },
})
export default class Item extends Vue {
  @State('id') stateId
  @State('styleId') styleId
  @State('index') stateIndex
  @State('producerId') producerId
  @State('releaseDate') releaseDate
  @State('styleListOpen') styleListOpen
  @State('resultLoading') stateResultLoading
  @State('producerListOpen') producerListOpen
  @Mutation('setId') mutationSetId
  @Mutation('setIndex') mutationSetIndex
  @Mutation('setStyleId') mutationSetStyleId
  @Mutation('setProducerId') mutationSetProducerId
  @Mutation('setStyleListStatus') setStyleListStatus
  @Mutation('setResultLoading') mutationSetResultLoading
  @Mutation('setProducerListStatus') setProducerListStatus
  @Action('getResult') actionGetResult
  @Action('getPlayList') actionGetPlayList

  fieldMap = FIELD_MAP // 筛选列表

  // 导航列表
  navList = [
    {
      id: 0,
      label: NAV_MAP.OPTION,
      name: '自选模式',
    },
    {
      id: 1,
      label: NAV_MAP.RECOMMEND,
      name: '推荐模式',
    },
  ]
  // 要显示的导航
  includeNav = ['style_id', 'producer_id']

  // 筛选后的选项
  filterList = []
  playIds: any = []
  isGetPlayList = false // 是否正在更新列表

  created() {
    this.getFilterContent()
    this.actionGetResult({
      page: 1,
    })
    this.getPlayIds()
  }

  get isResult() {
    return this.stateIndex === 0
  }

  // 获取筛选列表
  async getFilterContent() {
    try {
      const result: any = await $condition({
        season_type: SEASON_TYPE_MAP.DOCUMENTARY,
        index_type: INDEX_TYPE_MAP.DOCUMENTARY,
        type: TYPE_MAP.WEB,
      })
      // 获取筛选项
      const { filter: filterList = [] } = result || {}
      this.filterList = filterList.filter((item) => {
        return this.includeNav.includes(item.field)
      })
    } catch (err) {
      // 报错了就直接提示网络异常
      return false
    }
  }

  // 获取片单id
  async getPlayIds() {
    try {
      const result: any = await $getPlayIds()
      if (result) {
        const { list } = result || {}
        this.playIds = list || []
        const first = list[0].line[0]
        this.mutationSetId(first.id)
      }
    } catch (err) {
      // 默认兜底
      this.playIds = PLAY_IDS
      const first = PLAY_IDS[0].line[0]
      this.mutationSetId(first.id)
    }
  }

  // 导航点击
  handleNavClick(item) {
    const { id, label } = item || {}
    this.mutationSetIndex(id)
    if (label === NAV_MAP.OPTION) {
      // 请求筛选的片单
      this.getResult()
    } else if (label === NAV_MAP.RECOMMEND) {
      // 请求推荐的片单
      this.getRecommendResult()
    }
  }

  // 筛选项点击
  handleOptionClick(option, field) {
    // 如果接口还正在请求，则提示查询中
    if (this.stateResultLoading) {
      return false
    }
    const { keyword } = option || {}
    // 根据不同的类型更新对应的参数
    switch (field) {
      case FIELD_MAP.STYLE_ID:
        // 如果点击的是同一个的话那么就不请求数据
        if (keyword === this.styleId) {
          return false
        }
        this.mutationSetStyleId(keyword)
        break
      case FIELD_MAP.PRODUCER_ID:
        // 如果点击的是同一个的话那么就不请求数据
        if (keyword === this.producerId) {
          return false
        }
        this.mutationSetProducerId(keyword)
        break
      default:
        break
    }

    // 开始请求接口
    this.getResult()
  }

  // 推荐片单点击
  handleRecommendClick(item) {
    const { id } = item || {}
    this.mutationSetId(id)
    // 请求片单数据
    this.getRecommendResult()
  }

  // 去请求筛选列表
  getResult() {
    // 开始请求接口
    this.actionGetResult({
      page: 1,
    })
  }

  // 去请求推荐片单
  async getRecommendResult() {
    if (this.isGetPlayList) {
      toast.info('片单查询中')
      return false
    }
    this.isGetPlayList = true
    await this.actionGetPlayList({ id: this.stateId })
    this.isGetPlayList = false
  }

  // 列表展开
  openList(field) {
    if (field) {
      switch (field) {
        case FIELD_MAP.STYLE_ID:
          // 点击的是风格的列表展开
          this.setStyleListStatus(true)
          break
        case FIELD_MAP.PRODUCER_ID:
          // 点击的是出品方的列表展开
          this.setProducerListStatus(true)
          break
        default:
          break
      }
    }
  }
}
